export const getFooterYear = () => new Date().getFullYear();
